import { Component } from '@angular/core';
import { GamesGroupService, IPollQuestion } from '@fgb/core';
import { Observable } from 'rxjs';
import { NavigationService } from '@fgb/portal-component-library/src/lib/shared/services';
import { ProductCode } from 'src/app/shared/utilities/product-code';
@Component({
  selector: 'fgb-polls-page',
  templateUrl: './polls-page.component.html',
  styleUrl: './polls-page.component.scss',
})
export class PollsPageComponent {
  productCode = ProductCode;
  pollsQuestion$: Observable<IPollQuestion[]>;

  constructor(
    private gamesGroupService: GamesGroupService,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    this.navigationService.hideMobileNav();
    this.pollsQuestion$ = this.gamesGroupService.fetchPolls();
  }

  ngOnDestroy(): void {
    this.navigationService.showMobileNav();
  }
}
